import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyDateFormat } from "../../../../../utils/hooks/company";
import moment from "moment-timezone";
import { renderUserName } from "../../../../../utils/helpers/user";

const columnHelper = createColumnHelper();

export const StatusCell = ({ value }) => {
    const { t } = useTranslation();

    let color, backgroundColor;
    switch (value) {
        case "deleted": {
            color = "red";
            backgroundColor = "#ff000012"
            break;
        }
        case "finished": {
            color = "#8b0000";
            backgroundColor = "#8b00001a";
            break;
        }
        case "pending": {
            color = "orange";
            backgroundColor = "#ffa5001c";
            break;
        }
        case "current": {
            color = "green";
            backgroundColor = "#00800014";
            break;
        }
        default:
            break;
    }

    return value && (
        <span className="px-3 py-1 rounded" style={{ color, backgroundColor }}>
            {t(value)}
        </span>
    );
}

export const useColumns = ({ edit, remove }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    return useMemo(() => {
        const columns = [
            columnHelper.accessor("startEffectiveDate", {
                enableColumnFilter: true,
                header: t("start-effective-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat);
                },
            }),
            columnHelper.accessor("endEffectiveDate", {
                enableColumnFilter: true,
                header: t("end-effective-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value && moment(value).format(dateFormat);
                },
            }),
            columnHelper.accessor("createdBy", {
                enableColumnFilter: true,
                header: t("created-by"),
                cell: (info) => {
                    const value = info.getValue();
                    return renderUserName(value);
                },
            }),
            columnHelper.accessor("status", {
                enableColumnFilter: true,
                header: t("status"),
                cell: (info) => {
                    const value = info.getValue();
                    return <StatusCell value={value} />
                },
            }),
            columnHelper.display({
                id: "actions",
                enableHiding: false,
                enableGlobalFilter: false,
                header: <div className="text-right">{t("actions")}</div>,
                cell: (info) => {
                    const { id, company, isDefault, status } = info.row.original;

                    return (
                        <div className="actions text-primary text-right">
                            {company && !isDefault && edit && status === "pending" && (
                                <span
                                    className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                    onClick={() => edit(info.row.original)}
                                >
                                    <i className="fas fa-pen" />
                                </span>
                            )}

                            {company && !isDefault && remove && status === "pending" && (
                                <span
                                    className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                    onClick={() => remove(id)}
                                >
                                    <i className="fas fa-trash" />
                                </span>
                            )}
                        </div>
                    );
                },
            }),
        ];
        return columns;
    }, [dateFormat, edit, remove, t]);
};
